import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LANDING } from "@/constants/testIds";

const STORAGE_KEY = "kr-cookie-preference";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const pref = window.localStorage.getItem(STORAGE_KEY);
      if (!pref) {
        // Slight delay so it doesn't fight the page load animation.
        const t = setTimeout(() => setVisible(true), 900);
        return () => clearTimeout(t);
      }
    } catch (_) {
      setVisible(true);
    }
  }, []);

  const set = (value) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (_) {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookies notice"
      data-testid={LANDING.cookieBanner}
      className="fixed z-[80] bottom-4 left-4 right-4 md:bottom-6 md:left-auto md:right-6 md:max-w-[440px]"
    >
      <div
        className="border border-[var(--kr-line)] bg-[rgba(10,13,18,0.95)] backdrop-blur-xl p-6 shadow-2xl"
      >
        <div className="flex items-center gap-3 mb-4">
          <span className="font-mono-label text-[10px] text-[var(--kr-gold)]">
            Cookies Notice
          </span>
          <span className="w-8 h-px bg-[var(--kr-gold)]/60" />
        </div>
        <p className="text-[var(--kr-text)] text-[14px] leading-[1.7] mb-5">
          We use a minimal set of cookies to ensure the website functions
          correctly and to monitor its integrity. No advertising or
          behavioural profiling.
        </p>
        <div className="flex flex-wrap items-center gap-4">
          <button
            type="button"
            data-testid={LANDING.cookieAccept}
            onClick={() => set("accepted")}
            className="kr-btn-primary text-[10px]"
            style={{ padding: "0.8rem 1.4rem" }}
          >
            Accept
          </button>
          <button
            type="button"
            data-testid={LANDING.cookieDecline}
            onClick={() => set("declined")}
            className="font-mono-label text-[11px] text-[var(--kr-text-muted)] hover:text-[var(--kr-gold)] transition-colors"
          >
            Decline
          </button>
          <Link
            to="/cookies"
            data-testid={LANDING.cookieLearnMore}
            className="font-mono-label text-[11px] text-[var(--kr-text-muted)] hover:text-[var(--kr-gold)] transition-colors ml-auto"
          >
            Learn More →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
